"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImportantNotice = void 0;
var _react = _interopRequireDefault(require("react"));
var ImportantNotice = function ImportantNotice() {
  return /*#__PURE__*/_react.default.createElement("section", {
    ariarole: "alert",
    arialabelledby: "important-information",
    className: "legal-notice"
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: "important-information"
  }, "Important Information About Procedures For Opening a New Account"), /*#__PURE__*/_react.default.createElement("p", null, " To help the government fight the funding of terrorism and money laundering activities, federal law requires all financial institutions to obtain, verify, and record information that identifies eah person who opens an account.  What this means for you: When you open an account, we will use your name, address, date of birth, and other information that will allow us to identify you."));
};
exports.ImportantNotice = ImportantNotice;
